import { render } from "./PayPanel_Culinary.vue?vue&type=template&id=2b77e004&scoped=true"
import script from "./PayPanel_Culinary.vue?vue&type=script&lang=js"
export * from "./PayPanel_Culinary.vue?vue&type=script&lang=js"

import "./PayPanel_Culinary.vue?vue&type=style&index=0&id=2b77e004&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b77e004"]])

export default __exports__